import {configureStore} from '../../store';

const store = configureStore();

const MEDIA_STORAGE_BASE_URL = 'https://rieltor-images.lunstatic.net/rieltor-ua-01';
const fallBackPrefix = 'images/';

const createMediaStorageAbsoluteUrl = (baseurl: string, path: string) =>
    `${baseurl}${path}`;
export const createResizedImageUrl = (
    imageKey: string,
    width: number,
    height: number) => {
  let baseUrl = store.getState().globalConfig.data?.mediaConfig?.cropperUrl || MEDIA_STORAGE_BASE_URL;
  if (imageKey.indexOf(fallBackPrefix) == -1) {
    baseUrl = MEDIA_STORAGE_BASE_URL;
  }
  return createMediaStorageAbsoluteUrl(baseUrl, `/${width}/${height}/${imageKey}`);
};

export const createSrcSet = (...urls: string[]) =>
    urls.map((url, index) => `${url} ${index + 1}x`).join(', ');
export const createRequireSrcSet = (...urls: string[]) =>
    urls.map((url, index) => `${require(url)} ${index + 1}x`).join(', ');

export const createLunResizedImageUrl = (
  imageKey: string,
  width: number,
  height: number
) => {
  return `https://market-images.lunstatic.net/lun-ua/${width}/${height}/images/${imageKey}.webp`;
};
